module.exports = __webpack_public_path__ + "static/Q4Answer6_Cute_JairoAlzate-5590cb1b77aba997fb7278e1479a412a.jpg";